<div class="max-w-3xl mx-auto px-4 py-16">
  <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">Roadmap</h1>
  <p class="text-gray-500 dark:text-gray-400 mb-10">
    Ce que nous construisons et ce qui arrive bientôt.
  </p>
  <div class="space-y-3">
    @for (item of items; track item.title) {
      <div
        class="flex items-start gap-4 p-4 rounded-xl border"
        [class]="
          item.status === 'done'
            ? 'border-green-100 bg-green-50 dark:bg-green-900/20'
            : item.status === 'wip'
              ? 'border-purple-200 dark:border-purple-800 bg-purple-50 dark:bg-purple-900/20'
              : 'border-gray-100 dark:border-slate-700 bg-white dark:bg-slate-800'
        "
      >
        <span class="text-lg shrink-0 mt-0.5">
          {{
            item.status === "done" ? "✅" : item.status === "wip" ? "🚧" : "📋"
          }}
        </span>
        <div class="flex-1">
          <div class="flex items-center gap-2">
            <h2 class="font-semibold text-gray-900 dark:text-white text-sm">
              {{ item.title }}
            </h2>
            <span
              class="text-[10px] px-2 py-0.5 rounded-full font-medium"
              [class]="
                item.status === 'done'
                  ? 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300'
                  : item.status === 'wip'
                    ? 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300'
                    : 'bg-gray-100 dark:bg-slate-800 text-gray-500 dark:text-gray-400'
              "
            >
              {{
                item.status === "done"
                  ? "Disponible"
                  : item.status === "wip"
                    ? "En cours"
                    : "Planifié"
              }}
            </span>
          </div>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ item.desc }}</p>
        </div>
      </div>
    }
  </div>
  <p class="text-center text-sm text-gray-400 mt-12">
    Une idée ?
    <a routerLink="/contact" class="text-purple-600 hover:underline"
      >Proposez-la</a
    >
  </p>
</div>
